export enum BuildingType {
    MFH = 'MFH',
    EFH = 'EFH',
}

export enum BuildingPart {
    VH = 'VH',
    HH = 'HH',
    SF = 'DF',
    QGB = 'QGB',
}

export enum BuildingPartDetail {
    NO_INFORMATION = '-1',
    LEFT = 'li',
    RIGHT = 're',
}
